<ng-container *ngIf="!isLoading; else loadingTemplate">
  <ng-container *ngIf="errorMessage">
    <div class="alert alert-danger text-start" role="alert">
      {{ errorMessage }}
    </div>
  </ng-container>
  <ng-container *ngIf="form && form.sections">
    <div class="mx-auto">
      <ng-container *ngIf="!hideTitle">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <div class="fw-800" style="font-size: 4rem; color: #430089">
            {{ form.title }}
          </div>
          <ng-container
            *ngIf="
              viewState === viewStates.GRADED &&
              submission?.pass_or_fail !== null &&
              submission?.grade !== null
            ">
            <div
              class="text-center"
              [ngClass]="{
                'text-success': submission?.pass_or_fail === 'pass',
                'text-danger': submission?.pass_or_fail === 'fail'
              }">
              <div class="fs-20">{{ submission?.grade }}</div>
              <div class="fw-bold fs-17">
                {{ submission?.pass_or_fail | titlecase }}
              </div>
            </div>
          </ng-container>
        </div>
        <div
          *ngIf="
            hasRequiredFields &&
            currentSectionIndex < form.sections.length &&
            viewState !== viewStates.SUBMITTED &&
            viewState !== viewStates.GRADED
          "
          class="text-danger mb-0">
          * Indicates required question
        </div>
        <hr class="border border-tertiary border-1 my-2" />
      </ng-container>
      <div
        *ngIf="
          viewState === viewStates.PREVIEW || viewState === viewStates.EDIT
        "
        class="fs-15 text-muted my-4">
        <div *ngIf="form.anonymity === ProFormAnonymity.REQUIRED">
          This form is anonymous. Your identity will not be recorded.
        </div>
        <div *ngIf="form.anonymity === ProFormAnonymity.NONE">
          This form is not anonymous. Your responses will be linked to your user
          account.
        </div>
      </div>
      <div class="mt-3">
        <ng-container *ngFor="let section of form.sections; let i = index">
          <ng-container *ngIf="i === currentSectionIndex">
            <ng-container *ngFor="let question of section.questions">
              <app-proforms-question
                [showMissed]="form.show_missed"
                [showAnswers]="form.show_answers"
                [submitted]="submitted"
                [question]="question"
                [viewState]="viewState"></app-proforms-question>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- Outro screen -->
        <ng-container *ngIf="currentSectionIndex > form.sections.length - 1">
          <div class="mb-5">
            <app-safehtml [html]="form.outro"></app-safehtml>
          </div>
          <ng-container *ngIf="submission">
            <div class="row justify-content-center mb-5">
              <div
                class="col-12 col-sm-6 col-lg-6 col-xxl-6 align-self-center"
                *ngIf="submission.pass_or_fail">
                <app-quick-stat
                  [label]="'Result'"
                  [stat]="submission.pass_or_fail | titlecase"
                  [statStyle]="
                    submission.pass_or_fail === 'pass' ? 'success' : 'danger'
                  " />
              </div>
              <div
                class="col-12 col-sm-6 col-lg-6 col-xxl-6 align-self-center"
                *ngIf="submission.grade != null">
                <app-quick-stat
                  [label]="'Grade'"
                  [stat]="submission.grade"
                  [statStyle]="
                    submission.pass_or_fail === 'pass' ? 'success' : 'danger'
                  " />
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <button
        class="btn btn-md btn-primary me-auto"
        (click)="prevSection()"
        *ngIf="
          currentSectionIndex !== 0 &&
          currentSectionIndex < form.sections.length
        ">
        <i class="bi bi-arrow-left"></i>
        Previous Section
      </button>
      <button
        class="btn btn-md btn-primary ms-auto"
        (click)="nextSection()"
        *ngIf="currentSectionIndex < form.sections.length - 1">
        Next Section
        <i class="bi bi-arrow-right"></i>
      </button>

      <ng-container
        *ngIf="
          currentSectionIndex > form.sections.length - 1 &&
          form.type === ProFormType.QUIZ &&
          submission &&
          form.show_missed
        ">
        <button
          class="btn btn-md btn-primary ms-auto"
          (click)="onGradedViewRequested()">
          View Graded Quiz
        </button>
      </ng-container>

      <button
        *ngIf="
          currentSectionIndex === form.sections.length - 1 &&
          viewState === viewStates.EDIT
        "
        [disabled]="submitLoading"
        (click)="submitForm()"
        class="btn btn-md btn-primary ms-auto">
        <ng-container *ngIf="submitLoading">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </ng-container>
        Submit
      </button>
    </div>
  </ng-container>
</ng-container>
<ng-template #loadingTemplate>
  <div
    class="w-100 position-relative"
    style="background-color: #fff; height: 500px">
    <app-loader></app-loader>
  </div>
</ng-template>
